import { useState, useRef, useEffect } from 'react'
import { MoreVertical } from 'lucide-react'

interface WidgetResizeMenuProps {
  currentWidth: 33 | 50 | 66 | 100
  onResize: (width: 33 | 50 | 66 | 100) => void
}

const WIDTH_OPTIONS: { value: 33 | 50 | 66 | 100; label: string }[] = [
  { value: 33, label: '33%' },
  { value: 50, label: '50%' },
  { value: 66, label: '66%' },
  { value: 100, label: '100%' },
]

export function WidgetResizeMenu({ currentWidth, onResize }: WidgetResizeMenuProps) {
  const [open, setOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(!open) }}
        className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
      >
        <MoreVertical className="h-4 w-4" />
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-20 p-2">
          <div className="inline-flex rounded-md shadow-sm" role="group">
            {WIDTH_OPTIONS.map((opt, i) => (
              <button
                key={opt.value}
                onClick={(e) => {
                  e.stopPropagation()
                  onResize(opt.value)
                  setOpen(false)
                }}
                className={`px-3 py-1.5 text-xs font-medium border border-gray-300 transition-colors
                  ${i === 0 ? 'rounded-l-md' : ''}
                  ${i === WIDTH_OPTIONS.length - 1 ? 'rounded-r-md' : ''}
                  ${i > 0 ? '-ml-px' : ''}
                  ${currentWidth === opt.value
                    ? 'bg-[#290BD9] text-white border-[#290BD9] z-10 relative'
                    : 'bg-white text-gray-700 hover:bg-gray-50'
                  }
                `}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
